export const CANONICAL_BASE = "https://www.privatemuse.com";
export const CANONICAL_PARAMS_WHITELIST = [];

export const DEFAULT_TITLE =
  "Acompanhantes virtuais 100% online | Private Muse";
export const DEFAULT_DESC =
  "Encontre acompanhantes virtuais para videochamada, chat privado, chamada de voz e conteudo personalizado. Perfis verificados, atendimento discreto e 100% online em todo o Brasil.";
export const DEFAULT_KEYWORDS =
  "acompanhantes virtuais, acompanhante virtual, acompanhantes online, atendimento virtual, videochamada, chamada de voz, chat privado, conteudo personalizado, perfis verificados, atendimento discreto, sexo virtual, acompanhantes virtuais no brasil, acompanhante online";

export const DEFAULT_IMAGE = "https://www.privatemuse.com/logo512.png";
export const DEFAULT_OG_TYPE = "website";
export const DEFAULT_SITE_NAME = "Private Muse";
export const DEFAULT_SITE_ALTERNATE_NAMES = ["PrivateMuse", "privatemuse.com"];
export const DEFAULT_LOCALE = "pt_BR";
export const DEFAULT_TWITTER_CARD = "summary_large_image";

export const NOINDEX_ROUTES = [
  "/login",
  "/signup",
  "/cadastro-email-musa",
  "/cadastro-musa-phone",
  "/cadastro-dados-e-senha-musa",
  "/cadastro-documento-musa",
  "/pagamentos",
  "/cookies",
  "/cliente/profile-setup",
  "/recuperar-senha",
  "/dashboard",
  "/cliente",
  "/perfilCliente",
  "/perfilMusa",
  "/musa/profile",
  "/musa/profile-setup",
  "/deactivate-account",
  "/delete-account",
];
